/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const INSIGHTS_SERVICE_NAME = `insights`;
export const DATASTORE_SERVICE_NAME = `datastore`;
